import React, { Component, useContext, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  Layout,
  Menu,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Switch,
} from "antd";
import signinbg from "../../assets/images/img-signin.jpg";
import nagarikAawaz from "../../assets/images/nagarik.jpg";
import {
  DribbbleOutlined,
  TwitterOutlined,
  InstagramOutlined,
  GithubOutlined,
} from "@ant-design/icons";
import { doLogin, fetchGeoStates } from "../../services/auth.service";
import { GlobalContext } from "../../context/GlobalContext";
import { showDangerMessage, showSuccessMessage } from "../../utils/notification.util";
const { Title } = Typography;
const { Footer, Content } = Layout;
export default function Login() {
  const navigate = useNavigate();
  const { user, setUser } = useContext(GlobalContext);
  const [message, setMessage] = useState("");
  const onFinish = (values) => {
    doLogin(values.email, values.password)
      .then((response) => {
        setUser(response.data);
        setMessage("login success");
        fetchGeoStates()
        .then((res) => {
          localStorage.setItem('ACCESS_TOKEN', response.data.access_token);
          localStorage.setItem('GEO_STATES', JSON.stringify(res.data));
          showSuccessMessage(`Login Success!`);
          navigate('/dashboard');
        })
      })
      .catch((error) => {
        console.log(error);
        // setMessage("login failed");
        showDangerMessage(`Invalid email or password!`);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <Layout className="layout-default layout-signin">
      <Content className="signin">
        <Row gutter={[24, 0]} justify="space-around">
          <Col
            xs={{ span: 24, offset: 0 }}
            lg={{ span: 6, offset: 2 }}
            md={{ span: 12 }}
          >
            <Title className="mb-15">Nagarik Aawaz</Title>
            <Title className="font-regular text-muted" level={5}>
              Enter your email and password to sign in
            </Title>
            <Form
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              layout="vertical"
              className="row-col"
            >
              <Form.Item
                className="username"
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please input your email!",
                  },
                ]}
              >
                <Input placeholder="Email" />
              </Form.Item>

              <Form.Item
                className="username"
                label="Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                ]}
              >
                <Input.Password placeholder="Password" />
              </Form.Item>
               <p>{message}</p> 
              {/* <Form.Item
                    name="remember"
                    className="aligin-center"
                    valuePropName="checked"
                  >
                    <Switch defaultChecked onChange={onChange} />
                    Remember me
                  </Form.Item> */}

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                >
                  SIGN IN
                </Button>
              </Form.Item>
            </Form>
            Forgot Password? <NavLink to={`/reset-password`}>Click Here</NavLink> to reset.
          </Col>
          <Col
            className="sign-img"
            style={{ padding: 12 }}
            xs={{ span: 24 }}
            lg={{ span: 12 }}
            md={{ span: 12 }}
          >
            <img src={nagarikAawaz} alt="" />
          </Col>
        </Row>
      </Content>
      <Footer>
        <Menu mode="horizontal" className="menu-nav-social">
          <Menu.Item>
            <Link to="#">{<DribbbleOutlined />}</Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="#">{<TwitterOutlined />}</Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="#">{<InstagramOutlined />}</Link>
          </Menu.Item>
        </Menu>
        <p className="copyright">
          {" "}
          Copyright © 2024 by <a href="#pablo">
            Firefly Services Pvt. Ltd.
          </a>.{" "}
        </p>
      </Footer>
    </Layout>
  );
}
